import { jsx as l, jsxs as r } from "react/jsx-runtime";
import "react";
var t = (c) => /* @__PURE__ */ r("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 36 36",
  ...c,
  children: [/* @__PURE__ */ l("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M20.8 32h-5.6c-5.28 0-7.92 0-9.56-1.64C4 28.72 4 26.08 4 20.8v-5.6c0-5.28 0-7.92 1.64-9.56C7.28 4 9.934 4 15.242 4c.848 0 1.528 0 2.1.023a2.105 2.105 0 0 0-.03.342L17.3 8.333c0 1.536 0 2.893.147 3.987.16 1.186.525 2.372 1.493 3.34.968.968 2.154 1.334 3.34 1.493 1.094.147 2.451.147 3.987.147h5.673c.06.748.06 1.666.06 2.888v.612c0 5.28 0 7.92-1.64 9.56C28.72 32 26.08 32 20.8 32ZM8.55 21.5c0-.58.47-1.05 1.05-1.05h11.2a1.05 1.05 0 1 1 0 2.1H9.6c-.58 0-1.05-.47-1.05-1.05Zm0 4.9c0-.58.47-1.05 1.05-1.05h7.7a1.05 1.05 0 1 1 0 2.1H9.6c-.58 0-1.05-.47-1.05-1.05Z",
    clipRule: "evenodd"
  }), /* @__PURE__ */ l("path", {
    fill: "currentColor",
    d: "M28.292 11.863 22.75 6.875c-1.579-1.42-2.368-2.131-3.337-2.503L19.4 8.2c0 3.3 0 4.95 1.025 5.975C21.45 15.2 23.1 15.2 26.4 15.2h5.012c-.508-.986-1.416-1.804-3.12-3.337Z"
  })]
});
export {
  t as default
};
